export const BULK_COLUMNS = {
  ORDERS: [
    { key: "client_id", header: "Client ID" },
    { key: "reference_no", header: "Reference No" },
    { key: "receiver_name", header: "Receiver Name" },
    { key: "receiver_mobile", header: "Receiver Phone" },
    { key: "receiver_email", header: "Receiver Email" },
    { key: "receiver_country", header: "Receiver Country" },
    { key: "receiver_city", header: "Receiver City" },
    { key: "receiver_district", header: "Receiver District" },
    { key: "receiver_address", header: "Receiver Address" },
    { key: "receiver_national_address", header: "Receiver National Address" },
    { key: "shipment_cost", header: "Shipment Cost" },
    { key: "payment_type", header: "Payment Type" },
    { key: "cod_amount", header: "COD Amount" },
    { key: "no_of_pieces", header: "No of Pieces" },
    { key: "weight", header: "Weight" },
    { key: "service", header: "Service" },
    { key: "shipment_type", header: "Shipment Type" },
    { key: "description", header: "Description" },
    { key: "latitude", header: "Latitute" },
    { key: "longitude", header: "Longitude" },
    { key: "reason", header: "Reason" },
  ],

  OUTSOURCE: [
    { key: "company_name", header: "Company Name" },
    { key: "full_name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "contact_person", header: "Contact Person" },
    { key: "contact_method", header: "Contact Method" },
    { key: "warehouse", header: "Warehouse" },
    { key: "payment_term", header: "Payment Term" },
    { key: "access_type", header: "Access Type" },
    { key: "client_type", header: "Client Type" },
    { key: "short_address", header: "Short Address" },
    { key: "location", header: "Location" },
    { key: "vat_number", header: "VAT Number" },
    { key: "cr_number", header: "CR Number" },
    { key: "national_id", header: "National ID" },
    { key: "contract_date", header: "Contract Date" },
    { key: "address", header: "Address" },
    { key: "service_area", header: "Service Area" },
    { key: "billing_cycle", header: "Billing Cycle" },
    { key: "reason", header: "Reason" },
  ],

  CLIENT: [
    { key: "full_name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "contact_person", header: "Contact Person" },
    { key: "contact_method", header: "Contact Method" },
    { key: "warehouse", header: "Warehouse" },
    { key: "payment_term", header: "Payment Term" },
    { key: "access_type", header: "Access Type" },
    { key: "client_type", header: "Client Type" },
    { key: "short_address", header: "Short Address" },
    { key: "location", header: "Location" },
    { key: "vat_number", header: "VAT Number" },
    { key: "cr_number", header: "CR Number" },
    { key: "national_id", header: "National ID" },
    { key: "contract_date", header: "Contract Date" },
    { key: "reason", header: "Reason" },
  ],

  STAFF: [
    { key: "full_name", header: "Full Name" },
    { key: "email", header: "Email" },
    { key: "phone", header: "Phone" },
    { key: "warehouse", header: "Warehouse" },
    { key: "supervisor_name", header: "Supervisor Name" },
    { key: "role", header: "Role" },
    { key: "start_date", header: "Start Date" },
    { key: "iqama_no", header: "Iqama Number" },
    { key: "reason", header: "Reason" },
  ],

  DRIVERS: [
    { key: "name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "warehouse", header: "Warehouse" },
    { key: "supervisor_name", header: "Supervisor Name" },
    { key: "start_date", header: "Start Date" },
    { key: "iqama_number", header: "Iqama Number" },
    { key: "vehicle_type", header: "Vehicle Type" },
    { key: "vehicle_name", header: "Vehicle Name" },
    { key: "license_number", header: "License Number" },
    { key: "reason", header: "Reason" },
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
// FAILED ROWS COLUMNS (Only key identifiers + reason)
// ─────────────────────────────────────────────────────────────────────────────
export const FAIL_COLUMNS = {
  ORDERS: [
    { key: "reference_no", header: "Reference No" },
    { key: "client_id", header: "Client ID" },
    { key: "reason", header: "Reason" },
  ],

  CLIENT: [
    { key: "name", header: "Full Name" },
    { key: "mobile", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  OUTSOURCE: [
    { key: "company_name", header: "Company Name" },
    { key: "mobile", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  STAFF: [
    { key: "full_name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  DRIVERS: [
    { key: "name", header: "Full Name" },
    { key: "mobile_no", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],
};
